import React from "react";
import { CustomChat, FacebookProvider } from "react-facebook";
import { Helmet } from "react-helmet";
import Banner from "./components/banner";
import Courses from "./components/courses";
import Instructors from "./components/instructors";
import Partners from "./components/partners";
import PrimeGallery from "./components/primeGallery/PrimeGallery";
import PrimeSlides from "./components/sliders/PrimeSlides";
import WhyChooseUs from "./components/whychooseus";

const FaceBookChat = () => {
  return (
    <FacebookProvider appId="276630555038332" chatSupport>
      <CustomChat pageId="100436718546734" minimized={true} />
    </FacebookProvider>
  );
};

const Prime = () => {
  return (
    <div className="w-full mx-auto">
      <Helmet>
        <title>Educare English Learning Academy</title>
      </Helmet>
      <Banner />
      <WhyChooseUs />
      <Courses />
      <Instructors />
      <Partners />
      <PrimeGallery />
      <PrimeSlides />
      <FaceBookChat />
    </div>
  );
};

export default Prime;
